/* Fonction pour initialiser les swiper "visual_scroller" & "jqzoom" */
function swiperJqzoomAndVisualScroller() {
    var productThumbs = new Swiper("#visual_scroller", { // Swiper Visual Scroller (mini images)
        slidesPerView: 3,
        spaceBetween: 38,
        direction: 'horizontal',
        loop: false,
        navigation: {
            prevEl: '.thumbPrev',
            nextEl: '.thumbNext',
        },

        breakpoints: {
            // when window width is >= 1281px
            1281: {
                spaceBetween: 30,
                direction: 'vertical'
            },
        },
        on: {
            init: function () {
                decodeVisibleSlides(this);
            },
            slideChange: function () {
                decodeVisibleSlides(this);
            }
        }
    });
    var main_productVisu = new Swiper("#jqzoom", { // Swiper Jqzoom (image principale)
        thumbs: {
            swiper: productThumbs
        },
        slidesPerView: 1,
        loop: false,
        on: {
            init: function () {
                decodeVisibleSlides(this);
            },
            slideChange: function () {
                decodeVisibleSlides(this);
            }
        }
    });
}

/*** is checked bundle fiche produit  (Function use in load page and in load product) ***/
function checkAddBasket() {
    $('.blocAddBasket').each(function () {
        if ($(this).find($('[name="unit_lot"]:checked')).length) {
            $(this).addClass('isChecked');
        } else {
            $(this).removeClass('isChecked');
        }
    });

    /** Recall of the function when clicking on batch inputs.**/
    $('.blocAddBasket').on("click", function () {
        checkAddBasket();
    });
}

$(function () {
    $('#shad_abox').on("click", function () {
        closeMultiShad();
        $('.lightbox.actif').removeClass('actif');
    });

    swiperJqzoomAndVisualScroller();

    /*see more rayon*/
    $('.thumbslide .see_more').on('click', function (e) {
        $('.thumbslide').removeClass('active');
        $(this).parents('.thumbslide').addClass('active');
    });

    /*** is checked bundle fiche produit ***/

    if ($('.wrapperAddBasket').length) {
        checkAddBasket();
    }
});

/* Fonction pour ouvrirune lightbox de l'image zoom
    Paramamètres :
        slide => image ou on souhaite afficher le zoom
*/
function zoomImg(slide) {
    if ($("#zoom_box_wrapper .swiper-slide").length > 0) { // Initialisation du Swiper du Zoom
        var main_productVisu = new Swiper('#zoom_box_wrapper', {
            slidesPerView: 1,
            navigation: {
                prevEl: '.zoomPrev',
                nextEl: '.zoomNext',
            },
            loadPrevNext: true,
            loadOnTransitionStart: true,
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        });
        main_productVisu.slideTo(slide - 1);
    }

    $('#zoom_box_wrapper .img_large').on('click', function () { // Fermeture de la lightbox et cacher le shad au clique sur l'image du zoom
        closeMultiShad('zoomBox');
    });

    openMultiShad('zoomBox'); // Ouverture de la lightbox zoom
}

/* Fonction pour gérer l'affichage de l'input alert stock ou cacher les messages de confirmation ou d'erreurs  */
function lightboxAlertStock() {

    var $taille_id = $("#tailleProd").val(),    // Récupère la valeur de la taille sélectionnée
        $couleur_id = $("#couleurProd").val();  // Récupère la valeur de la couleur séléctionnée

    if ($couleur_id == '') { // Si pas de couleurs sélectionnées
        alert(translate('js_error_couleur'));
        return;
    }

    var isFormVisible = $('.bloc_add_alert_form').is(':visible');               // Boolean  => Savoir l'input alert stock est visible
    var isMessageVisible = $('.bloc_add_alert_confirmation').is(':visible');    // Boolean  => Savoir le bloc de confirmation d'alert stock est visible
    var isErrorVisible = $('.bloc_add_alert_erreur').is(':visible');            // Boolean  => Savoir le bloc d'erreur d'alert stock est visible

    if (isFormVisible || isMessageVisible || isErrorVisible) {  // Si l'un des trois blocs est visible, on fait :

    } else {
        $('.bloc_add_alert_form').slideDown('fast'); // Sinon on affiche l'input Alert Stock
    }

    //display slide alert stock fiche produit
    if ($('body.product_page').length) {
        $('#shad_rollovermenu').addClass('actif');
        $('.container_lightbox_alert_stock').addClass('actif');
        /* Scrollbar lightbox produit indisponible */
        $('.container_lightbox_alert_stock').overlayScrollbars({
            scrollbars: {
                autoHide: "leave",
                autoHideDelay: 0,
            }
        });
    }

    if (wShop.$refs.wAlertestockForm) {
        wShop.$refs.wAlertestockForm.reloadBloc += 1;
    }
}

function closeLightboxStock() {
    if ($('body.product_page').length) {
        $('#shad_rollovermenu').removeClass('actif');
        $('.container_lightbox_alert_stock').removeClass('actif');
    }
}

function resetThumbSwiperFP() {
    var swiper_FP_main_push_height = $("#jqzoom").height();
    var swiper_FP_main_push_width = $("#jqzoom").width();
    $("#visual_scroller_wrapper").addClass('is-active');

}
